import * as types from "./actionTypes";
import adressenGatewayApi from "../api/shared/adressenGatewayApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";

// ----------------------------------------------------------------------------
function gemeentenLoaded(gemeenten) {
	return {
		type: types.GEMEENTEN_LOADED,
		body: gemeenten
	};
}

export function loadGemeenten() {
	return function (dispatch) {
		dispatch(ajax.started());
		return adressenGatewayApi.listGemeenten()
			.then((response) => {
				dispatch(ajax.ended());
				if (!response.data || typeof response.data === 'string')
					dispatch(exception.throwException("No valid reference data from api"));
				else
					dispatch(gemeentenLoaded(response.data));
			})
			.catch(error => {
				dispatch(ajax.failed());
				dispatch(exception.throwException(error));
			});
	};
}
